import { FormService } from './FormService';

class SurveyService extends FormService {}

const instance = new SurveyService('/surveys');
Object.freeze(instance);

export default instance;
